module.exports = __webpack_public_path__ + "static/media/service_system_13.beeae1fa.png";